export default __webpack_public_path__ + "static/media/abckitchen.3e275a02.jpeg";